import type { TournamentListItem } from '@brush/api-client';
import { useState } from 'react';
import { btnGhost, btnPrimary, Modal } from '../Modal';
import { changedFrom } from '../../dialogDrafts';
import { useUnsavedWork } from '../../unsaved';
import { TagInput } from '../TagInput';

export function EditTagsModal({
  tournament,
  allTags,
  platformTags,
  saving,
  onSave,
  onClose,
}: {
  tournament: TournamentListItem;
  allTags: string[];
  platformTags: string[];
  saving: boolean;
  onSave: (tags: string[]) => void;
  onClose: () => void;
}) {
  const [tags, setTags] = useState<string[]>(tournament.tags);
  // Asked about before a room switch or any other way out discards them (#591).
  useUnsavedWork(changedFrom(tournament.tags, tags));

  return (
    <Modal
      title="Edit tags"
      subtitle={`${tournament.name} · ${tournament.date}`}
      onClose={onClose}
      footer={
        <>
          <button type="button" onClick={onClose} className={btnGhost}>
            Cancel
          </button>
          <button type="button" onClick={() => onSave(tags)} disabled={saving} className={btnPrimary}>
            {saving ? 'Saving…' : 'Save tags'}
          </button>
        </>
      }
    >
      <TagInput value={tags} onChange={setTags} suggestions={allTags} platformTags={platformTags} />
      <p className="mt-3 text-[10px] text-ink-800/40">
        Platform tags carry a shield and can&apos;t be removed by rooms once applied.
      </p>
    </Modal>
  );
}
